import { PasswordInput, TextInput } from '@mantine/core';
import { useForm, zodResolver } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { useNavigate } from 'react-router-dom';

import { LoginFormDTO } from '@/shared/api';
import {
  useCurrentProject,
  useProjectPath,
} from '@/shared/projects/project-path';
import { useGlobalStore } from '@/shared/stores/global.store';
import { Button, Checkbox } from '@/shared/ui';

import { schemas, useLogin } from '../model';
import styles from './login-form.module.scss';

export const LoginForm = () => {
  const navigate = useNavigate();
  const project = useCurrentProject();
  const withProject = useProjectPath();
  const mutation = useLogin(project);
  const setToken = useGlobalStore((state) => state.setToken);
  const setUserData = useGlobalStore((state) => state.setUserData);

  const form = useForm({
    mode: 'uncontrolled',
    validateInputOnChange: true,
    initialValues: {
      email: '',
      password: '',
    },
    validate: zodResolver(schemas.loginFormSchema),
  });

  const onSubmit = async (data: LoginFormDTO) => {
    mutation.mutate(data, {
      onSuccess({ accessToken }) {
        setToken(project, accessToken);
        setUserData(project, { name: 'Администратор', email: data.email });
        navigate(withProject('/books'));
      },
      onError(error) {
        notifications.show({
          message: `Ошибка авторизации: ${error.message}`,
          color: 'red',
        });
      },
    });
  };

  return (
    <form onSubmit={form.onSubmit(onSubmit)} className={styles.form}>
      <TextInput
        label="Email"
        placeholder="Введите  почту"
        type="email"
        key={form.key('email')}
        {...form.getInputProps('email')}
        disabled={mutation.isPending}
      />
      <PasswordInput
        label="Пароль"
        placeholder="Введите пароль"
        key={form.key('password')}
        {...form.getInputProps('password')}
        className={styles.passwordInput}
        disabled={mutation.isPending}
      />
      <Checkbox label="Запомнить меня" className={styles.checkbox} />
      <Button
        buttonType="Primary"
        type="submit"
        className={styles.button}
        loading={mutation.isPending}
      >
        Войти
      </Button>
    </form>
  );
};
